import { LegalPage, type LegalSection } from '@/components/legal/legal-page';

const sections: readonly LegalSection[] = [
  {
    title: 'Information we collect',
    body: [
      'We collect account details such as your email address, phone number, name, profile photo, biography, and links when you provide them. We also store club memberships, event registrations, check-ins, attendee-form answers, friendships, reminders, and notification preferences needed to operate the club.',
      'If you choose to upload media, we store profile photos, event media, and related file metadata. If you connect a third-party service such as Google Calendar, Instagram, or Strava, we process the identifiers, authorization tokens, and activity or calendar data needed for the feature you requested.',
      'The app and its infrastructure may process device identifiers, push notification tokens, app version, platform, timestamps, IP addresses, screens and pages viewed, interaction events, performance data, and security or error logs needed to deliver, understand, and protect the service.',
      'We use PostHog for product analytics, session replay, in-app surveys, error tracking, and operational logs. Session replay masks text inputs and images in the native apps, masks form inputs on the web, and does not record network request or response bodies. Replays are used to diagnose problems and improve the product, not for advertising.',
    ],
  },
  {
    title: 'How we use information',
    body: [
      'We use this information to authenticate accounts, publish and manage run-club events, register and check in members, show member profiles, send event updates and reminders, support connected services, respond to support requests, understand feature usage and survey feedback, prevent abuse, and maintain service reliability.',
      '6am BKK does not sell personal information and does not use personal information for third-party advertising or cross-app tracking.',
    ],
  },
  {
    title: 'Service providers and sharing',
    body: [
      'We share information only as needed with infrastructure and platform providers that operate the app, including Supabase for authentication, database, and storage services; Expo for app builds and notifications; PostHog for product analytics, session replay, surveys, logs, and error tracking; Apple and Google for distribution and sign-in; and a connected service when you explicitly enable that integration.',
      'We may disclose information when required by law, to protect users or the service, or as part of a business transfer subject to appropriate safeguards. Public profile fields and event information are visible according to the settings shown in the app.',
    ],
  },
  {
    title: 'Device permissions',
    body: [
      'Camera access is used for member QR scanning. Photo-library access is used only when you choose a profile photo or event image. Calendar access is used to add events when you request it. Notification permission is used for event updates and reminders. You can change these permissions in your device settings.',
    ],
  },
  {
    title: 'Retention and deletion',
    body: [
      'We retain account information while your account is active and as needed to provide the service. You can permanently delete your account from Account settings in the app. Deletion removes your profile, memberships, registrations, contacts, connected-service records, notification tokens, routes, and account uploads. If you are the only owner of a club, ownership is transferred to another club member when possible so the club can continue for its members.',
      'Limited operational or security records may be retained when required by law or needed to resolve abuse, fraud, or security incidents. Where practical, retained records are de-identified and are not used to recreate a deleted profile.',
    ],
  },
  {
    title: 'Your choices and contact',
    body: [
      'You can update your profile and communication settings in the app, disconnect integrations, revoke device permissions, or delete your account. For access, correction, deletion, or privacy questions, contact ajay.koenig@gmail.com.',
      'This service is operated as 6am BKK for its Bangkok run-club community. Material changes to this policy will be posted on this page with a new updated date.',
    ],
  },
];

export default function PrivacyScreen() {
  return (
    <LegalPage
      actions={[
        { href: '/account-deletion', label: 'Account deletion' },
        { href: '/support', label: 'Contact support', variant: 'secondary' },
      ]}
      intro="How 6am BKK handles information in the mobile app and club platform."
      sections={sections}
      title="Privacy policy"
      updatedAt="31 July 2026"
    />
  );
}
